module.exports = __webpack_public_path__ + "static/media/bed.eed4a7e9.svg";